export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Em andamento"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Concluído"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pendente"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Próximo"])}
}